import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import ProductsPreview from './components/ProductsPreview';
import ValueSection from './components/ValueSection';
import CommercialSection from './components/CommercialSection';
import CTASection from './components/CTASection';

const HomePage = () => {
  return (
    <main>
      <HeroSection />
      <ServicesSection />
      <ProductsPreview />
      <ValueSection />
      <CommercialSection />
      <CTASection />
    </main>
  );
};

export default HomePage;
